<template>
  <section class="contact">
    
    <div class="wrapper">
      <div class="titles">
        <h3 class="titles__subtitle">Contact me</h3>
        <h2 class="titles__title">And you, what do you do<br/>
          <span class="framed">for good</span> ?
        </h2>
        <div class="titles__text">
          <p>Have a project, a position? Tell me your greater goal: </p>
          <p><a :href="'mailto:'+contactEmail">{{contactEmail}}</a></p>
          <!-- <p><a v-on:click="copyEmail">{{contactEmail}}</a></p> -->
        </div>
        
      </div>
    </div>


  </section>
</template>

<script>

export default {
  name: 'About',
  data () {
    return {
      contactEmail: 'noefalque+portfolio@gmail.com'
    }
  },
  // methods() {
  //   copyEmail: function(e) {
  //     alert('h')
  //              TODO : https://www.raymondcamden.com/2020/03/04/vue-quick-shot-copy-to-the-clipboard
  //   }
  // }
  props: ['theme']
}

</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/_Contact.vue